import React from 'react';
import Container from '@/components/ui/Container/Container.tsx';
import ButtonLink from '@/components/ui/ButtonLink/ButtonLink.tsx';
import MainLayout from '@/layouts/MainLayout/MainLayout.tsx';
import styles from './AlkSsoRedirect.module.scss';
import { alkOnboardEmployeeLink } from '@/constants/auth.ts';

const AlkSsoRedirect: React.FC = () => {
	return (
		<MainLayout>
			<Container>
				<div className={styles.alkSsoRedirectContainer}>
					<p>
						<span>Dear Traveller,</span> This link is only for existing users. If you don't have a profile
						yet, please create your Goodwings profile using this registration link and remember to use your
						short ALK (XXXDK@ALK.NET) email adress in your profile.
					</p>
					<ButtonLink href={alkOnboardEmployeeLink} color="green" size="large">
						Create a profile
					</ButtonLink>
				</div>
			</Container>
		</MainLayout>
	);
};

export default AlkSsoRedirect;
